import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMinus = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 12c0-.552.384-1 .857-1h18.286c.473 0 .857.448.857 1s-.384 1-.857 1H2.857C2.384 13 2 12.552 2 12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgMinus;
